<style lang="less" scoped>
	.editable {
		cursor: pointer;
	}
</style>

<template>
	<hr v-bind:class="classes" />
</template>




<script type="text/javascript">
	export default {
		name: "EditorHr",
		props: {
			focus: {type: Object },
			element: {type: Object}
		},
		data: () =>{
			return {
			}
		}, 
		computed:{
			classes(){
				var object = {}
				object[this.element.attrs.padding] = this.element.attrs.padding ? true : false;
				object[this.element.attrs.margin] = this.element.attrs.margin ? true : false;
				return object;
			}
		},

		watch:{
			focus: {
				immediate:true,
				handler(){
					if( this.focus == this.element ){
						this.editing = true
					}
					else{
						this.editing = false
					}
				}
			}
		}
	}
</script>

